import { Form, Input } from "antd";
import React from "react";
import getInTouch from "../../common/assets/images/getInTouch.png";
import facebook from "../../common/assets/images/contactUsFacebook.svg";
import whatsaap from "../../common/assets/images/contactUsWhatsaap.svg";
import twitter from "../../common/assets/images/contactUsTwitter.svg";
import call from "../../common/assets/images/blueCallOutline.svg";
import message from "../../common/assets/images/blueMessageOutlined.svg";
import location from "../../common/assets/images/blueLocationOutline.svg";
import contactBlueSvg from "../../common/assets/images/contactBlueSvg.svg";

const GetInTouch = () => {
  return (
    <div className="bg-[#C1F0FB] relative">
      <img src={contactBlueSvg} className="absolute left-[33%]" alt="" />
      <div className="bg-[#EBEFFF] rounded-b-[174px] pt-[67px]">
        <div className="container flex">
          <div className="w-[60%] z-20 ">
            <h2 className="text-[3rem]">
              Lets Get in <span className="font-bold">Touch!</span>
            </h2>
            <p className="text-base w-[65%] pt-3">
              Have a question or need assistance? Reach out to us via email,
              phone, or the contact form below. We're eager to assist you.
            </p>
            <p className="font-bold pt-2">Nice hearing from you!</p>

            <div className="contactUsImage absolute left-[9%] top-[29%]">
              <img src={getInTouch} className="w-[93%]" alt="" />
            </div>
          </div>

          <div className="w-[40%] relative z-20">
            <Form layout={"vertical"} className="getInTouchForm">
              <Form.Item label="Full Name">
                <Input className="bg-transparent" />
              </Form.Item>
              <Form.Item label="Email">
                <Input className="bg-transparent" />
              </Form.Item>
              <Form.Item label="Phone No">
                <Input className="bg-transparent" />
              </Form.Item>
              <Form.Item label="Message">
                <Input.TextArea className="bg-transparent" />
              </Form.Item>
              <Form.Item>
                <button className="darkBlue text-white rounded py-2 px-[80px]">
                  Submit
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
      <div className="pt-[123px]  flex justify-end pb-10">
        <div className="flex gap-3 absolute  left-[10%] bottom-[10%] ">
          <img src={facebook} width={45} height={45} alt="" />
          <img src={whatsaap} width={45} height={45} alt="" />
          <img src={twitter} width={45} height={45} alt="" />
        </div>
        <div className="flex justify-end pr-[125px] ">
          <div className="font-medium">
            <h6 className="font-medium text-3xl pb-6">Head Office: </h6>
            <div className="flex gap-2 items-center pb-3">
              <img src={call} alt="" />
              <p className="">+01234567891</p>
            </div>
            <div className="flex gap-2 pb-3 items-center">
              <img src={message} alt="" />
              <p className="">Example@gmail.com</p>
            </div>
            <div className="flex gap-2 items-center">
              <img src={location} alt="" />
              <p className="w-[70%]">2068 Boulevard Henri-Bourassa Est</p>
            </div>
          </div>
          <div className="font-medium">
            <h6 className="font-medium text-3xl pb-6">Branch Office: </h6>
            <div className="flex gap-2 items-center pb-3">
              <img src={call} alt="" />
              <p className="">+01234567891</p>
            </div>
            <div className="flex gap-2 pb-3 items-center">
              <img src={message} alt="" />
              <p className="">Example@gmail.com</p>
            </div>
            <div className="flex gap-2 items-center">
              <img src={location} alt="" />
              <p className="w-[70%]">2068 Boulevard Henri-Bourassa Est</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
